import * as Constants from './Constants';

export const addRecent = (recent) => ({
    type: Constants.ADD_RECENT,
    recent
});



// WEBPACK FOOTER //
// ./src/modules/state/recent/Actions.js